import { render, staticRenderFns } from "./QueueEditor.vue?vue&type=template&id=3c59a894&"
import script from "./QueueEditor.vue?vue&type=script&lang=js&"
export * from "./QueueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports